/*
  Purekey: dopolnila za mobilni meni v sections/pk-header.liquid (PLAN 2.4).
  Odpiranje, zapiranje, zaklep drsenja in ujetje fokusa ostanejo Flowovi (theme.min.js MobileMenu), Esc dodamo sami.
  Poslušalci so na nivoju dokumenta, zato delujejo tudi po osvežitvi sekcije v urejevalniku.
*/
(() => {
  if (window.pkHeaderLoaded) return;
  window.pkHeaderLoaded = true;

  const DRAWER_OPEN_CLASS = 'js-drawer-open-left';
  const isOpen = () => document.body.classList.contains(DRAWER_OPEN_CLASS);
  const closeDrawer = () => window.wetheme?.toggleLeftDrawer?.(false);

  // Flow (theme.js tabindexMobileNav) nastavi tabindex="-1" na povezave predala nad 767 px,
  // mobilna glava pa velja do 989 px. Brez popravka pri 768–989 px ujetje fokusa ne najde povezav.
  // Zajem (capture) teče pred Flowovim klikom, ki ustvari FocusTrap.
  document.addEventListener(
    'click',
    (event) => {
      if (!event.target.closest('.js-drawer-open-left-link')) return;
      document
        .querySelectorAll('#NavDrawer a[tabindex="-1"], #NavDrawer button[tabindex="-1"]')
        .forEach((element) => element.removeAttribute('tabindex'));
    },
    true
  );

  // Esc zapre meni: Flowov MobileMenu ustvari FocusTrap brez povratnega klica onEscape
  // (theme.js, `new FocusTrap(container)`), zato tipko obravnavamo sami.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !isOpen()) return;
    closeDrawer();
  });

  // aria-expanded na hamburgerju in vrnitev fokusa ob zaprtju (Flowov MobileMenu tega ne naredi)
  let wasOpen = isOpen();
  new MutationObserver(() => {
    const open = isOpen();
    if (open === wasOpen) return;
    wasOpen = open;

    const burger = document.querySelector('.js-drawer-open-left-link');
    burger?.setAttribute('aria-expanded', String(open));

    const drawer = document.getElementById('NavDrawer');
    const focusInDrawer = drawer?.contains(document.activeElement) || document.activeElement === document.body;
    if (!open && burger && focusInDrawer) burger.focus({ preventScroll: true });
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // Košarica in drugi predali pred odprtjem sprožijo close:all:drawers — meni se zapre,
  // da drsenje strani ne ostane zaklenjeno, ko se košarica zapre.
  window.eventBus?.on('close:all:drawers', () => {
    if (isOpen()) closeDrawer();
  });

  // Senca ploščic ob drsenju: bele ploščice so nad belo vsebino sicer nevidne.
  // Flowov razred .sticked (IntersectionObserver) se ne nastavi zanesljivo, zato lasten razred.
  let scrollTicking = false;
  const updateScrolled = () => {
    document.documentElement.classList.toggle('pk-header-scrolled', window.scrollY > 0);
    scrollTicking = false;
  };
  window.addEventListener(
    'scroll',
    () => {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(updateScrolled);
    },
    { passive: true }
  );
  updateScrolled();

  // Pri prehodu na desktop glavo (990 px) se meni zapre in sprosti drsenje
  window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
    if (event.matches && isOpen()) closeDrawer();
  });
})();
